<template>
  <div :class="['main-navbar', 'bg-white', stickyTop ? 'sticky-top' : '']">
    <d-navbar type="light" class="align-items-stretch flex-md-nowrap p-0">
      <navbar-search />
      <navbar-nav />
      <navbar-toggle />
    </d-navbar>
    <!-- FREE account alert banner to upgrade -->
    <d-alert class="text-center" v-if="showFreeAccountBanner" theme="success" show>
      {{ $t("banner.title") }}
      <a class="alert-link font-weight-bold ml-1" href="/plan">
        <u>{{ $t("banner.cta") }}</u>
      </a>
    </d-alert>
  </div>
</template>

<script>
import NavbarSearch from "./NavbarSearch.vue";
import NavbarNav from "./NavbarNav.vue";
import NavbarToggle from "./NavbarToggle.vue";

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getCurrentUser"]),
    showFreeAccountBanner() {
      return this.getCurrentUser && !this.getCurrentUser.premium;
    }
  },
  data() {
    return {
      freeAccount: true
    };
  },
  components: {
    NavbarSearch,
    NavbarNav,
    NavbarToggle
  },
  props: {
    /**
     * Whether the main navbar should be sticky, or not.
     */
    stickyTop: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss">
.main-navbar {
  .dropdown-menu {
    display: block;
  }
}
</style>
